"use strict";
/* eslint-disable */
//This file is autogenerated by the generateFile function from generateChargeMethodRecords.util
Object.defineProperty(exports, "__esModule", { value: true });
class ChargeMethodRecords {
    static shipping = {
        "flat": {
            "shortton": [
                "count"
            ],
            "transaction": [
                "count"
            ],
            "lineitems": [
                "count"
            ],
            "hundredweight": [
                "count"
            ],
            "primaryunits": [
                "count",
                "countlessotheruoms",
                "weight",
                "volume"
            ],
            "secondaryunits": [
                "count",
                "countlessotheruoms",
                "weight",
                "volume"
            ],
            "packagingunits": [
                "count",
                "countlessotheruoms",
                "weight",
                "volume"
            ],
            "moveableunits": [
                "count",
                "countlessotheruoms",
                "weight",
                "volume"
            ],
            "lot": [
                "count",
                "hundredweight",
                "shortton"
            ],
            "location": [
                "count"
            ],
            "itemclass": [
                "count",
                "hundredweight",
                "shortton"
            ],
            "sku": [
                "count",
                "hundredweight",
                "shortton"
            ],
            "totalpackages": [
                "count",
                "weight"
            ],
            "totalmus": [
                "count",
                "volume"
            ],
            "uniquemulabels": [
                "count",
                "areasqft",
                "areasqm"
            ]
        }
    };
    static shippingMU = {
        "flat": {
            "moveableunits": [
                "count",
                "countlessotheruoms",
                "weight",
                "volume"
            ],
            "totalmus": [
                "count",
                "volume"
            ],
            "uniquemulabels": [
                "count",
                "areasqft",
                "areasqm"
            ]
        }
    };
    static receiving = {
        "flat": {
            "uniquemulabels": [
                "count",
                "areasqft",
                "areasqm"
            ],
            "shortton": [
                "count"
            ],
            "transaction": [
                "count"
            ],
            "numberofpackagedunits": [
                "count"
            ],
            "numberofpalletized": [
                "count"
            ],
            "lineitems": [
                "count"
            ],
            "hundredweight": [
                "count"
            ],
            "primaryunits": [
                "count",
                "countlessotheruoms",
                "weight",
                "volume"
            ],
            "secondaryunits": [
                "count",
                "countlessotheruoms",
                "weight",
                "volume"
            ],
            "packagingunits": [
                "count",
                "countlessotheruoms",
                "weight",
                "volume"
            ],
            "moveableunits": [
                "count",
                "countlessotheruoms",
                "weight",
                "volume"
            ],
            "lot": [
                "count",
                "hundredweight",
                "shortton"
            ],
            "location": [
                "count"
            ],
            "itemclass": [
                "count",
                "hundredweight",
                "shortton"
            ],
            "sku": [
                "count",
                "hundredweight",
                "shortton"
            ]
        }
    };
    static receivingMU = {
        "flat": {
            "moveableunits": [
                "count",
                "countlessotheruoms",
                "weight",
                "volume"
            ],
            "numberofpalletized": [
                "count"
            ],
            "uniquemulabels": [
                "count",
                "areasqft",
                "areasqm"
            ]
        }
    };
    static returns = {
        "flat": {
            "totalvolume": [
                "count"
            ],
            "shortton": [
                "count"
            ],
            "transaction": [
                "count"
            ],
            "numberofpackagedunits": [
                "count"
            ],
            "numberofpalletized": [
                "count"
            ],
            "lineitems": [
                "count"
            ],
            "hundredweight": [
                "count"
            ],
            "primaryunits": [
                "count",
                "countlessotheruoms",
                "weight",
                "volume"
            ],
            "secondaryunits": [
                "count",
                "countlessotheruoms",
                "weight",
                "volume"
            ],
            "packagingunits": [
                "count",
                "countlessotheruoms",
                "weight",
                "volume"
            ],
            "moveableunits": [
                "count",
                "countlessotheruoms",
                "weight",
                "volume"
            ],
            "lot": [
                "count",
                "hundredweight",
                "shortton"
            ],
            "location": [
                "count"
            ],
            "itemclass": [
                "count",
                "hundredweight",
                "shortton"
            ],
            "sku": [
                "count",
                "hundredweight",
                "shortton"
            ]
        }
    };
    static adjustments = {
        "flat": {
            "location": [
                "count"
            ],
            "transaction": [
                "count"
            ],
            "qty": [
                "count"
            ],
            "lineitems": [
                "count"
            ],
            "lot": [
                "count"
            ],
            "sku": [
                "count"
            ]
        }
    };
    static assemblies = {
        "flat": {
            "location": [
                "count"
            ],
            "transaction": [
                "count"
            ],
            "totalqty": [
                "count"
            ],
            "totalkits": [
                "count"
            ],
            "lot": [
                "count"
            ],
            "sku": [
                "count"
            ]
        }
    };
}
exports.default = ChargeMethodRecords;
